var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c104_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.94451 0.310015L18.5598 8.50999C18.5598 8.50999 19.6097 9.48447 18.4667 9.48447C17.3253 9.48447 14.5607 9.48447 14.5607 9.48447C14.5607 9.48447 14.5607 10.1409 14.5607 11.1491C14.5607 14.0371 14.5607 19.2833 14.5607 21.4187C14.5607 21.4187 14.7194 22 13.8168 22C12.9177 22 5.59982 22 4.95501 22C4.31365 22 4.32831 21.514 4.32831 21.514C4.32831 19.436 4.32831 14.0084 4.32831 11.2208C4.32831 10.3181 4.32831 9.72746 4.32831 9.72746C4.32831 9.72746 2.11286 9.72746 0.721527 9.72746C-0.669808 9.72746 0.379297 8.70826 0.379297 8.70826C0.379297 8.70826 7.95751 1.04741 8.77731 0.244206C9.3747 -0.341326 9.94451 0.310015 9.94451 0.310015Z",
    fill: "url(#paint0_linear_28_4300)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_4300",
    x1: 9.5,
    y1: 0,
    x2: 9.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#149069"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowUp);
export default __webpack_public_path__ + "static/media/grow-up.09ebfaa1bd24a8bc7f178f461271eeba.svg";
export { ForwardRef as ReactComponent };